module.exports = __webpack_public_path__ + "img/objetos-31.07d52137.png";